export const contentData = {
  spanish:{
    layout:{
      title:'Agregar usuarios',
      navigation:[
        {name:'Usuarios',path:'/users'},
        {name:'Agregar',path:'/users/add'},
      ],
      menu:null
    },
    header:['ID','Nombre','Email','Teléfono','Género']
  }
}